import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { components } from '@atlaskit/select';
import { fontFallback } from '@atlaskit/theme/typography';
import { columnPickerMessages } from './messages';
export var SELECT_ITEMS_MAXIMUM_THRESHOLD = 200;
var messageStyles = css({
  color: "var(--ds-text-subtle, #44546F)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-body-small, ".concat(fontFallback.body.small, ")"),
  fontWeight: "var(--ds-font-weight-regular, 400)"
});
export var ConcatenatedMenuListOld = function ConcatenatedMenuListOld(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var shouldUseDefaultMenuList = !children || !Array.isArray(children) || children.length <= SELECT_ITEMS_MAXIMUM_THRESHOLD;
  if (shouldUseDefaultMenuList) {
    return jsx(components.MenuList, props, children);
  }
  var optionStyle = {
    padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-200, 16px)"),
    height: 'auto'
  };
  var maximumLimitReachedMessage =
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  jsx("div", {
    css: messageStyles,
    style: optionStyle
  }, jsx(FormattedMessage, _extends({
    tagName: 'div'
  }, columnPickerMessages.maximumItemsShownLine1)), jsx(FormattedMessage, _extends({
    tagName: 'div'
  }, columnPickerMessages.maximumItemsShownLine2)));
  return jsx(components.MenuList, props, children.slice(0, SELECT_ITEMS_MAXIMUM_THRESHOLD), maximumLimitReachedMessage);
};